export default __webpack_public_path__ + "static/media/spinner.05270b4c.svg";